import { render } from "./CalendarTemplate.vue?vue&type=template&id=65b2b683"
import script from "./CalendarTemplate.vue?vue&type=script&lang=js"
export * from "./CalendarTemplate.vue?vue&type=script&lang=js"
script.render = render

export default script